export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

export const getNestField = (obj: any, fieldPath: string) => {
  return fieldPath.split('.').reduce((curr, key) => curr && curr[key], obj);
};
